/**
 * @GENERATED from Figma node 3638:51952
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const CadBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="m3.403 16.964-.045-9.996L11.963 2l8.634 5.036.045 9.996L12.037 22zm1.859-7.798 5.794 3.38.03 6.707-5.794-3.38z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(CadBright);
export { ForwardRef as CadBright };
